module.exports = __webpack_public_path__ + "media/images/white-ghost-95195c628c2d604888b858b40f5d66b2.gif";